var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 7.7869H2.71509C2.24376 7.7869 1.8623 7.43485 1.8623 6.99989C1.8623 6.56494 2.24378 6.21289 2.71509 6.21289H14.6087C15.08 6.21289 15.4615 6.56494 15.4615 6.99989C15.4839 7.43487 15.08 7.7869 14.6087 7.7869Z",
    fill: "#3E3F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4716 1.57401H0.852789C0.381453 1.57401 0 1.22196 0 0.787003C0 0.352045 0.381473 0 0.852789 0H16.494C16.9653 0 17.3468 0.352045 17.3468 0.787003C17.3468 1.22196 16.9653 1.57401 16.4716 1.57401H16.4716Z",
    fill: "#3E3F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4716 13.9998H0.852789C0.381453 13.9998 0 13.6477 0 13.2128C0 12.7778 0.381473 12.4258 0.852789 12.4258H16.494C16.9653 12.4258 17.3468 12.7778 17.3468 13.2128C17.3468 13.6477 16.9653 13.9998 16.4716 13.9998H16.4716Z",
    fill: "#3E3F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuIcon);
export default __webpack_public_path__ + "static/media/mobile-menu-icon.683cfd7460c9dad45e9e743fc59d00a9.svg";
export { ForwardRef as ReactComponent };